import { useEffect, useRef, useState } from "react";
import getParameterByName from "@utils/getQueryParams";
import { useDispatch, useSelector } from "react-redux";
import { liveChatLoaded } from "segments/eventActions/misc";
import { getVideoData } from "@store/indexModule/actions";
/**
 * this hook run only once, which in turn triggers only one r2d2 event
 * it takes the following params
 *
 * @hookCondition: calling component prior condition to run hook
 * @callback: callback function to run only once
 */

export const useRunOnceHook = ({ hookCondition, callback }: any): any => {
  const [isUseEffectHookFired, setIsUseEffectHookFired] = useState(false);

  return useEffect(() => {
    if (hookCondition && !isUseEffectHookFired) {
      callback();
      setIsUseEffectHookFired(true);
    }
  }, [hookCondition]);
};
const scriptEndpoint = {
  master: "https://ackogi-uat.allincall.in/files/deploy/embed_chatbot_1.js",
  production: "https://ackogi.allincall.in/files/deploy/embed_chatbot_1.js"
};

export const useLiveChatScript = (show: boolean) => {
  // dependency is prop to dynamically add remove script based on user interaction
  const scriptAlreadyAdded = useRef<boolean>(false);
  const dispatch = useDispatch();
  const { vehicleAge } = useSelector(({ proposalDataReducer }: any) => {
    return {
      vehicleAge: proposalDataReducer?.data?.vehicleAge
    };
  });
  // to dynamically show hide chatbot based on user interaction
  useEffect(() => {
    if (
      scriptAlreadyAdded.current &&
      document.getElementById("allincall-popup-wrapper")
    ) {
      if (!show)
        document.getElementById("allincall-popup-wrapper")!.style.display =
          "none";
      else
        document.getElementById("allincall-popup-wrapper")!.style.display =
          "flex";
    }
  }, [show]);
  useEffect(() => {
    const now = new Date().getHours();
    const isWithinWorkingHours = now > 9 && now < 19;
    const script = document.createElement("script");
    script.src =
      scriptEndpoint[process.env.ENVIRONMENT?.toLocaleLowerCase() as string];
    script.async = true;
    // base condition to inject script
    if (
      getParameterByName("utm_source")?.toLowerCase() !== "partnerships" &&
      isWithinWorkingHours &&
      vehicleAge >= 5 &&
      !scriptAlreadyAdded.current
    ) {
      scriptAlreadyAdded.current = true;
      document.body.appendChild(script);
      dispatch(liveChatLoaded({ vehicle_age: vehicleAge }));
    }
    return () => {
      scriptAlreadyAdded.current && document.body.removeChild(script);
    };
  }, [vehicleAge]);
};

export const useGetVideos = (
  groupId: string,
  proposalFetchSuccess: boolean,
  videoId: string
) => {
  const dispatch = useDispatch();

  const { videoList } = useSelector(({ indexReducer }: any) => ({
    videoList: indexReducer?.videos
  }));

  useEffect(() => {
    const requestedVideoObj = videoList?.[videoId];

    if (!Object.keys(requestedVideoObj || {}).length) {
      dispatch(getVideoData(groupId));
    }
  }, [proposalFetchSuccess]);
};
export default {};
